import { RefreshCw, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePWAUpdate } from '@/hooks/usePWAUpdate';
import { t } from '@/lib/i18n';

export function PWAUpdatePrompt() {
  const { needsUpdate, isUpdating, update, dismiss } = usePWAUpdate();

  if (!needsUpdate) return null;

  const updateBody = t('pwa.update.body').replace('{brand}', t('brand.name'));

  return (
    <div className="fixed top-20 right-4 z-50 max-w-sm bg-white rounded-xl shadow-lg border border-brand-lagune-200 p-4">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-brand-lagune-100 flex items-center justify-center">
          <RefreshCw className="w-5 h-5 text-brand-lagune-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-slate-900">
            Mise à jour disponible
          </p>
          <p className="text-xs text-slate-500 mt-1">
            {updateBody}
          </p>
          <div className="flex gap-2 mt-3">
            <Button
              size="sm"
              onClick={update}
              disabled={isUpdating}
              aria-busy={isUpdating}
              className="bg-brand-lagune-700 hover:bg-brand-lagune-800 text-xs"
            >
              {isUpdating ? (
                <>
                  <RefreshCw className="w-3.5 h-3.5 mr-1.5 animate-spin motion-reduce:animate-none" />
                  Mise à jour…
                </>
              ) : (
                'Mettre à jour'
              )}
            </Button>
            <Button
              size="sm"
              variant="ghost"
              onClick={dismiss}
              disabled={isUpdating}
              className="text-xs text-slate-500"
            >
              Plus tard
            </Button>
          </div>
        </div>
        <button
          onClick={dismiss}
          className="flex-shrink-0 text-slate-400 hover:text-slate-600"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
